<template>
  <v-row>
    <v-col>
      <v-row align="center" class="mb-4">
        <v-col>
          <v-alert
            v-if="saveError"
            type="error"
            dense
            class="mb-0"
          >
            Não foi possível salvar no momento. Tente novamente.
          </v-alert>

          <v-alert
            v-else-if="hasUnsavedChanges"
            type="warning"
            dense
            class="mb-0"
          >
            <strong>
              Alterações não salvas. Salve antes de mudar de aba.
            </strong>
          </v-alert>
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="
              disabled ||
              saving ||
              !hasUnsavedChanges
            "
            @click="saveSurgeryPreoperative"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>

            Salvar
          </v-btn>
        </v-col>
      </v-row>

      <SurgeryDetail :surgery="surgery" />

      <Allergy
        :attendance="attendance"
        :showForm="!disabled"
        :allowDelete="!disabled"
      />

      <MedicationHistory
        :attendance="attendance"
        :showForm="!disabled"
        :allowDelete="!disabled"
      />

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Questionário
        </v-col>
      </v-row>

      <v-row align="end">
        <v-col cols="2">
          <v-row dense>
            <v-col>
              Paciente em jejum
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="fasting"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="changeFasting"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-text-field
            v-model="fastingTime"
            label="Tempo"
            dense
            hide-details
            outlined
            background-color="white"
            :disabled="!fasting || disabled"
            @input="handleChange"
          />
        </v-col>

        <v-col cols="3">
          <v-row dense>
            <v-col>
              Hipertensão arterial sistêmica
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="hypertension"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="handleChange"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-row dense>
            <v-col>
              Diabetes
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="diabetes"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="handleChange"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-row dense>
            <v-col>
              Retirado prótese
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="prosthesisRemoved"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="handleChange"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-row dense>
            <v-col>
              Acesso venoso periférico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="venousAccess"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="changeVenousAccess"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3">
          <v-row dense>
            <v-col>
              Membro
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="venousAccessSite"
                row
                dense
                hide-details
                outlined
                :disabled="!venousAccess || disabled"
                :items="venousAccessSites"
                background-color="white"
                @change="handleChange"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="auto">
          <v-row dense>
            <v-col>
              Infecção
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="infection"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                :disabled="disabled"
                @change="handleChange"
              >
                <v-radio
                  label="Sim"
                  :value="true"
                />

                <v-radio
                  label="Não"
                  :value="false"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-textarea
            v-model="observation"
            label="Notas"
            placeholder=" "
            hide-details
            outlined
            background-color="white"
            :disabled="disabled"
            @input="handleChange"
          />
        </v-col>
      </v-row>

      <SurgeryVitalMeasurementList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <SurgeryTherapyList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <v-row dense>
        <v-col class="text-h5 gray--text">
          Anexos
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Preoperative"
            :ownerId="preoperative.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import MedicationHistory from "@/components/medical_record/hpp/medication_history.vue";
import SurgeryDetail from "@/components/surgery/detail.vue";
import SurgeryVitalMeasurementList from "@/components/surgery/vital_measurement/list/index.vue";
import SurgeryTherapyList from "@/components/surgery/therapy/list/index.vue";

export default {
  name: "SurgeryPreoperative",

  props: {
    surgery: Object,
    refreshSurgery: Function,
    setSurgeryMoment: Function,
    surgeryMoment: String,

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Allergy,
    MedicationHistory,
    SurgeryDetail,
    SurgeryVitalMeasurementList,
    SurgeryTherapyList,
  },

  data() {
    return {
      initializing: true,
      saving: false,
      saveError: null,
      initialSnapshot: null,

      fasting: false,
      fastingTime: "",
      hypertension: false,
      diabetes: false,
      prosthesisRemoved: false,
      venousAccess: false,
      venousAccessSite: "",
      infection: false,
      observation: "",

      venousAccessSites: [
        "Superior direito",
        "Superior esquerdo",
        "Inferior direito",
        "Inferior esquerdo",
      ],
    };
  },

  computed: {
    attendance() {
      return this.surgery.attendance;
    },

    preoperative() {
      return this.surgery.preoperative || {};
    },

    hasUnsavedChanges() {
      if (
        this.initializing ||
        this.initialSnapshot === null
      ) {
        return false;
      }

      return (
        this.createSnapshot() !==
        this.initialSnapshot
      );
    },
  },

  async mounted() {
    this.initializing = true;

    this.fasting =
      this.preoperative.fasting ?? false;

    this.fastingTime =
      this.preoperative.fastingTime || "";

    this.hypertension =
      this.preoperative.hypertension ?? false;

    this.diabetes =
      this.preoperative.diabetes ?? false;

    this.prosthesisRemoved =
      this.preoperative.prosthesisRemoved ??
      false;

    this.venousAccess =
      this.preoperative.venousAccess ?? false;

    this.venousAccessSite =
      this.preoperative.venousAccessSite || "";

    this.infection =
      this.preoperative.infection ?? false;

    this.observation =
      this.preoperative.observation || "";

    this.setSurgeryMoment("preoperative");

    await this.$nextTick();

    this.captureSnapshot();

    this.initializing = false;
  },

  methods: {
    normalizeText(value) {
      return String(value || "")
        .replace(/\r\n/g, "\n")
        .trim();
    },

    createSnapshot() {
      return JSON.stringify({
        fasting: Boolean(this.fasting),

        fastingTime: this.normalizeText(
          this.fastingTime
        ),

        hypertension: Boolean(
          this.hypertension
        ),

        diabetes: Boolean(this.diabetes),

        prosthesisRemoved: Boolean(
          this.prosthesisRemoved
        ),

        venousAccess: Boolean(
          this.venousAccess
        ),

        venousAccessSite: this.normalizeText(
          this.venousAccessSite
        ),

        infection: Boolean(this.infection),

        observation: this.normalizeText(
          this.observation
        ),
      });
    },

    captureSnapshot() {
      this.initialSnapshot =
        this.createSnapshot();
    },

    handleChange() {
      if (
        this.initializing ||
        this.disabled ||
        this.saving
      ) {
        return;
      }

      /*
       * hasUnsavedChanges é calculado pelo snapshot.
       * Aqui apenas removemos um erro anterior quando
       * o operador volta a editar.
       */
      this.saveError = null;
    },

    changeFasting() {
      if (
        this.initializing ||
        this.disabled ||
        this.saving
      ) {
        return;
      }

      if (!this.fasting) {
        this.fastingTime = "";
      }

      this.handleChange();
    },

    changeVenousAccess() {
      if (
        this.initializing ||
        this.disabled ||
        this.saving
      ) {
        return;
      }

      if (!this.venousAccess) {
        this.venousAccessSite = "";
      }

      this.handleChange();
    },

    async saveSurgeryPreoperative() {
      if (
        this.disabled ||
        this.saving ||
        !this.hasUnsavedChanges
      ) {
        return;
      }

      this.saving = true;
      this.saveError = null;

      /*
       * Registra exatamente o estado enviado.
       * Se houver edição durante a request, o estado
       * posterior continuará aparecendo como alterado.
       */
      const snapshotBeingSaved =
        this.createSnapshot();

      try {
        await this.apolloMutate({
          mutation: require(
            "@/graphql/surgery/save_surgery_preoperative.gql"
          ),

          variables: {
            surgeryId: this.surgery.id,

            fasting: this.fasting,

            fastingTime:
              this.fastingTime,

            hypertension:
              this.hypertension,

            diabetes: this.diabetes,

            prosthesisRemoved:
              this.prosthesisRemoved,

            venousAccess:
              this.venousAccess,

            venousAccessSite:
              this.venousAccessSite,

            infection: this.infection,

            observation: this.observation,
          },
        });

        /*
         * O estado efetivamente enviado passa a ser
         * o novo baseline.
         */
        this.initialSnapshot =
          snapshotBeingSaved;

        /*
         * Atualiza os dados gerais da cirurgia somente
         * após a mutation concluir.
         */
        await this.refreshSurgery();
      } catch (error) {
        this.saveError = error;

        console.error(
          "Erro ao salvar pré-operatório:",
          error
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
